import { render, staticRenderFns } from "./fourEmotions.vue?vue&type=template&id=407b5a14&scoped=true"
import script from "./fourEmotions.vue?vue&type=script&lang=js"
export * from "./fourEmotions.vue?vue&type=script&lang=js"
import style0 from "./fourEmotions.vue?vue&type=style&index=0&id=407b5a14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407b5a14",
  null
  
)

export default component.exports